var MpPageBulletin;

(function() {
    var TITLE_DELTA_SIZE = 4;
    var EXCERPT_MAX_LENGTH = 320;
    var BULLETIN_PATH = '/resources/bulletin/';

    if (!document.querySelector('#vue-body-bulletin')) {
        return;
    }

    MpPageBulletin = new Vue({
        el: '#vue-body-bulletin',
        mixins: [MpPaginator],
        data: {
            BULLETIN_SEARCH_PAGE_URL: '/bulletin/index/format/json/page/',

            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            TYPE_CATEGORY: 'category',
            TYPE_EQUIPMENT: 'equipment',

            // This initial values comes from PHP BulletinController
            SEARCH_RESULTS: searchingResultsTxt,
            SEARCH_RESULTS_WORD: searchingResultsWithWordTxt,
            SEARCH_RESULTS_CATEGORY: searchingResultsWithCategoryTxt,

            totalResultsTPL: '',
            totalResultsWordTPL: '',
            totalResultsCategoryTPL: '',
            totalResultsTxt: '',
            totalItems: 0,

            word: '',
            category: 0,
            equipmentCategories: [],

            categoryFullList: [],
            equipmentsCategoryFullList: [],

            highlightedList: [],
            adList: [],

            allChecked: false,
            advancedSearch: false,
            isInitialized: false,
        },

        computed: {

            categoryName: function() {
                var i = 0,
                    total = this.categoryFullList.length,
                    found = false;

                while (!found && i<total) {
                    if (this.categoryFullList[i].id === this.category) {
                        found = true;
                    } else {
                        i++;
                    }
                }

                return (found) ? this.categoryFullList[i].name : '';
            },

            dataSearch: function() {
                return Serializer.serialize({
                    'filters': 'filtering',
                    'word': this.word,
                    'categories': (this.category>0) ? [this.category] : [],
                    'equipment_categories': this.equipmentCategories,
                });
            },

        },

        methods: {

            getTypeClass: function(typeToken) {
                return 'bulletin-info__category--'+typeToken;
            },

            filterById: function(list, idList) {
                return list.filter(function (item) {
                    return idList.indexOf(item.id) >= 0;
                });
            },

            toggleAdvancedSearch: function() {
                this.advancedSearch = !this.advancedSearch;
            },

            setAllChecks: function(value) {
                var i;

                this.allChecked = value;
                this.equipmentCategories = [];

                for (i=0; i<this.equipmentsCategoryFullList.length; i++) {
                    this.equipmentsCategoryFullList[i].selected = this.allChecked;
                    if (this.allChecked) {
                        this.equipmentCategories.push(this.equipmentsCategoryFullList[i].id);
                    }
                }
            },

            resetFilters: function() {
                this.word = '';
                this.category = 0;
                this.equipmentCategories = [];

                this.filters = 'reset'; // to reset server session filters
            },

            selectTag: function(e) {
                var type = e.currentTarget.getAttribute('data-type'),
                    id = e.currentTarget.getAttribute('data-id'),
                    token = e.currentTarget.getAttribute('data-token');

                this.resetFilters();

                if (type === this.TYPE_CATEGORY) {
                    this.category = parseInt(id);
                    this.loadItems();
                } else {
                    this.equipmentCategories = [parseInt(id)];
                    this.loadItems();
                }
            },

            updateResultsText: function() {
                if (this.word !== '') {
                    this.totalResultsTxt = this.totalResultsWordTPL.replace('%s', this.totalItems);
                    this.totalResultsTxt =  this.totalResultsTxt.replace('%s', this.word);
                    return;
                }

                if (this.category != 0) {
                    this.totalResultsTxt = this.totalResultsCategoryTPL.replace('%s', this.totalItems);
                    this.totalResultsTxt =  this.totalResultsTxt.replace('%s', this.categoryName);
                    return;
                }

                this.totalResultsTxt = this.totalResultsTPL.replace('%s', this.totalItems);
            },

            // extractHighlights: function(list) {
            //     var i;

            //     return list.filter(function(item) {
            //         return parseInt(item.highlight) === 0;
            //     });
            // },

            addDomAdvert: function(item) {
                var i,
                    advert,
                    nImages = parseInt(item.getAttribute('data-pics')),
                    isHighlighted = parseInt(item.getAttribute('data-highlighted'));

                advert = {
                    token: item.getAttribute('data-token'),
                    url: item.getAttribute('data-link'),
                    publicationDate: item.getAttribute('data-date'),
                    title: item.getAttribute('data-title'),
                    description: item.getAttribute('data-description'),
                    category: {
                        id: item.getAttribute('data-category-id'),
                        name: item.getAttribute('data-category'),
                        token: item.getAttribute('data-category-token'),
                    },
                    highlight: isHighlighted,
                    statusSold: item.getAttribute('data-status-sold'),
                    statusSoldTitle: item.getAttribute('data-status-sold-title'),
                    equipmentCategories: item.getAttribute('data-equipment-categories'),
                    hasImages: parseInt(item.getAttribute('data-pics')) > 0,
                    nImages: nImages,
                };

                for (i=1; i<=nImages; i++) {
                    advert['thumb'+i] = item.getAttribute('data-thumb'+i) || '';
                    advert['image'+i] = item.getAttribute('data-image'+i) || '';
                }

                if (isHighlighted && !advert.statusSold) {
                    this.highlightedList.push(advert);
                }

                this.adList.push(advert);
            },

            createCategory: function(item) {
                return {
                    id: parseInt(item.getAttribute('data-value')),
                    name: item.getAttribute('data-name'),
                    token: item.getAttribute('data-token'),
                    selected: item.getAttribute('data-selected') !== '',
                };
            },

            addCategory: function(item) {
                var category = this.createCategory(item);

                this.categoryFullList.push(category);

                if (category.selected) {
                    this.category = category.id;
                }
            },

            addEquipmentCategory: function(item) {
                var category = this.createCategory(item);

                this.equipmentsCategoryFullList.push(category);

                if (category.selected) {
                    this.equipmentCategories.push(category.id);
                }
            },

            onSearchLoaded: function(response) {
                if (response.data.result == this.RESPONSE_OK) {
                    this.adList = response.data.adverts;
                    this.totalItems = parseInt(response.data.total);

                    this.updateResultsText();
                    this.updatePaginator(response);

                    MpEventBus.$emit(EVENT_BULLETIN_SEARCH);
                }
            },

            loadItems: function(isPagination) {

                if (!isPagination && this.page !== 1) {
                    this.setPage(1);
                }

                // Set proper filters value depending the request type
                this.filters = (!isPagination) ? (this.filters || 'ok') : '';

                axios
                .post(this.BULLETIN_SEARCH_PAGE_URL + this.page, this.dataSearch)
                .then(this.onSearchLoaded)
                .catch(function(error) {
                    console.log(error);
                });
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                window.addEventListener('hashchange', this.onHashChange);
                this.onHashChange();

                this.initPaginator();
                this.advancedSearch = this.equipmentCategories.length > 0;
                this.isInitialized = true;
            },

            sendForm: function() {
                // REVIEW: validate filters?
                if (true) {
                    this.loadItems();
                }
            },
        },

        filters: {

            defaultImage: function(image) {
                return (image) ? image : BULLETIN_PATH + 'bulletin_default.svg';
            },

            excerpt: function (text, title, image) {
                if (!text) {
                    return '';
                }

                var excerptSize,
                    ending;

                excerptSize = EXCERPT_MAX_LENGTH - title.length * TITLE_DELTA_SIZE;
                ending = (excerptSize > 0 && text.length > excerptSize) ? '...' : '';

                return (excerptSize > 0) ? text.substring(0, excerptSize) + ending : '';
            }
        },

        mounted: function() {
            this.$refs.ssrAdList.querySelectorAll('.js-item').forEach(this.addDomAdvert);
            this.$refs.ssrCategoryList.querySelectorAll('.js-category').forEach(this.addCategory);
            this.$refs.ssrEquipmentCategoryList.querySelectorAll('.js-equipment-category').forEach(this.addEquipmentCategory);

            this.$refs.ssrPaginator.querySelectorAll('.js-page-item').forEach(this.addDomPage);

            this.word = this.$refs.word.getAttribute('data-init');
            this.totalResultsTPL = this.$refs.ssrSearchResults.getAttribute('data-tpl');
            this.totalResultsWordTPL = this.$refs.ssrSearchResults.getAttribute('data-tpl-word');
            this.totalResultsCategoryTPL = this.$refs.ssrSearchResults.getAttribute('data-tpl-category');
            this.totalItems = parseInt(this.$refs.ssrSearchResults.getAttribute('data-total'));
            this.totalResultsTxt = this.$refs.ssrSearchResults.getAttribute('data-init');

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
            window.removeEventListener('hashchange', this.onHashChange);
        }
    });

})();
